import { render } from "./ProductSerialNumber.vue?vue&type=template&id=6cd8882c&scoped=true&ts=true"
import script from "./ProductSerialNumber.vue?vue&type=script&lang=ts"
export * from "./ProductSerialNumber.vue?vue&type=script&lang=ts"

import "./ProductSerialNumber.vue?vue&type=style&index=0&id=6cd8882c&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd8882c"]])

export default __exports__